import {Directive, ElementRef} from '@angular/core';

// TODO: Add more capabilities like 'show/hide password' text or toggle
// TODO: Replace with a component that has a template
@Directive({
    selector: '[appPassword]',
    standalone: true
})
export class AppPasswordDirective {

  private visible = false;
  private eye: HTMLElement;

  constructor(private el: ElementRef) {
    this.setup();
  }

  private setup(): void {
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.classList.add('input-group-text', 'input-group-addon-right');

    this.eye = document.createElement('i');
    this.eye.classList.add('fa', 'fa-eye');

    span.appendChild(this.eye);
    span.addEventListener('click', (event) => {
      this.toggle();
    });

    parent.appendChild(span);
  }

  private toggle(): void {
    this.visible = !this.visible;

    if (this.visible) {
      this.el.nativeElement.type = 'text';
      this.eye.classList.add('fa-eye-slash');
      this.eye.classList.remove('fa-eye');
    } else {
      this.el.nativeElement.type = 'password';
      this.eye.classList.add('fa-eye');
      this.eye.classList.remove('fa-eye-slash');
    }
  }
}
